import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase-config";
import BaseChart from "./BaseChart";

export default function BalanceSheetAnalysis({
  periodIndex,
  id,
  years,
  period,
}) {
  // Balance Sheet
  const [assets, setAssets] = React.useState([]);
  const [liabilities, setLiabilities] = React.useState([]);
  const [equity, setEquity] = React.useState([]);
  const [balanceSheetYears, setBalanceSheetYears] = React.useState([]);
  const [name, setName] = React.useState();

  // Loading State
  const [balanceSheetLoading, setbalanceSheetLoading] = React.useState(true);

  async function fetchIncomeStatements({ id, period, periodIndex, years }) {
    setbalanceSheetLoading(true);
    const q = query(
      collection(db, "companies-financials"),
      where("company-id", "==", id),
      where("year", "in", years),
      where("type", "==", "Balance Sheet"),
      where("period", "==", period),
      where("period-index", "==", periodIndex)
    );

    const allDocs = [];
    const totalAssets = [];
    const totalLiabilities = [];
    const totalEquity = [];
    const dataYears = [];
    let companyName;

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      allDocs.push(doc.data());
      companyName = doc.data()["name"];
    });

    allDocs.sort((a, b) => a["year"] - b["year"]);

    allDocs.forEach((doc) => {
      totalAssets.push(doc["Total Assets"]);
      totalLiabilities.push(doc["Total Liabilities"]);
      totalEquity.push(doc["Total Shareholder's Equity"]);
      dataYears.push(doc["year"]);
    });

    setAssets(totalAssets);
    setLiabilities(totalLiabilities);
    setEquity(totalEquity);
    setBalanceSheetYears(dataYears);
    setName(companyName);
    setbalanceSheetLoading(false);
  }

  React.useEffect(() => {
    fetchIncomeStatements({
      id: id,
      period: period,
      periodIndex: periodIndex,
      years: years,
    });
  }, [years, id, period, periodIndex]);

  return balanceSheetLoading ? (
    <h4>Loading</h4>
  ) : (
    <>
      {/* <Typography variant="h5" align="center">
        {name}
      </Typography> */}
      <Typography variant="h5" align="center">
        Balance Sheet Trend
      </Typography>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Total Assets"
              data={assets}
              categories={balanceSheetYears}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Total Liabilities"
              data={liabilities}
              categories={balanceSheetYears}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Shareholder's Equity"
              data={equity}
              categories={balanceSheetYears}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
